import { Dialog } from "@mui/material";
import { useEffect, useState } from "react";
import { configState } from "../lib/State";
import axios from "axios";

export default function EventPopup({ cid, WhatsNewClick }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState();

  useEffect(() => {
    const popuptime = +localStorage.getItem("popup_time");
    const now = new Date().getTime();
    if (popuptime && +popuptime && popuptime > now) return;
    const getPopup = async () => {
      const result = await axios.post(configState.api + "/gympass/get_popup", {
        cid,
      });
      if (!result?.data?.success) return;
      if (!result.data.row?.id) return;
      setData(result.data.row);
      setOpen(true);
    };
    getPopup();
  }, []);

  const gotoDetails = () => {
    setOpen(false);
    WhatsNewClick();
  };

  return (
    <Dialog open={open} fullScreen onClose={() => setOpen(false)}>
      {data && (
        <div className="w-full flex flex-col h-full">
          <div className="overflow-x-auto flex flex-col flex-1">
            <img src={data.popup_img} alt="" onClick={gotoDetails} />
          </div>
          <div className="mt-auto py-3 text-center">
            <div className="flex justify-center items-center flex-1">
              <div
                className="text-center w-[90%] mx-auto py-2 rounded-full mb-2 text-base font-semibold"
                style={{
                  ...data.meta_popup,
                }}
                onClick={gotoDetails}
              >
                자세히 보기
              </div>
            </div>
            <div className="flex text-sm">
              <div
                onClick={() => {
                  localStorage.setItem(
                    "popup_time",
                    new Date().getTime() + 24 * 60 * 60 * 1000
                  );
                  setOpen(false);
                }}
                className="flex-1 py-2"
              >
                오늘하루 안보기
              </div>
              <div onClick={() => setOpen(false)} className="flex-1 py-2">
                닫기
              </div>
            </div>
          </div>
        </div>
      )}
    </Dialog>
  );
}
